import { buildCheckboxInitialOptions } from '../buildCheckboxInitialOptions';
import { buildTableList } from '../buildTableList';
import { buildCheckboxOptionFromState } from '../buildCheckboxOptionFromState';
import {
  BuildTableModelsSectionsArgs,
  BuildTableModelsSectionsReturn,
} from './model';

export const buildTableModelsSections = ({
  addConnectorData,
  preconfiguredModels,
  selectedDestination,
}: BuildTableModelsSectionsArgs): BuildTableModelsSectionsReturn[] => {
  const modelSections: BuildTableModelsSectionsReturn[] = [];
  addConnectorData.sources?.forEach((source) => {
    addConnectorData.models?.forEach((model) => {
      const isCompatible = model.compatiblePreconfiguredSources.some(
        (compatible) => compatible === source.preconfiguredSourceName
      );
      if (!isCompatible) {
        return;
      }
      const options: string[] = buildTableList({
        preconfiguredModels,
        model,
      });

      const { checkboxForm, selectedAll } = addConnectorData.destinations
        ? buildCheckboxOptionFromState({
            connectorDataDestinations: addConnectorData.destinations,
            selectedDestination,
            options,
            model,
          })
        : buildCheckboxInitialOptions({
            options,
          });

      const data = {
        sourceDisplayName: source.displayName,
        modelDisplayName: model.displayName,
        modelName: model.name,
        modelStableVersion: model.stableVersion,
        selectedAll,
        options,
        checkboxForm,
      };

      modelSections.push(data);
    });
  });

  return modelSections || [];
};
